import Vue from 'vue'
import App from './App.vue'

import router from './router/router';
import store from '@/store/store.js';

import '../static/css/base.css';
import '../static/css/icon.css';

import 'lib-flexible'

Vue.directive('numberOnly', {
  bind: function (el) {
    el.handler = function () {
      el.childNodes[1].value = el.childNodes[1].value.replace(/^[\u4e00-\u9fa5]+$/, '');
    }
    el.addEventListener('keyup', el.handler);
  },
  unbind: function (el) {
    el.removeEventListener('keyup', el.handler);
  }
})

// 抛出路由错误
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
